export default __webpack_public_path__ + "static/media/googlePlay_es.fc8be61b.png";